import { useState } from "react";
import { ActivateSuccess } from "../components/ActivateSuccess";
import { ActivateForm } from "../components/ActivateForm";

export const Index = () => {
  const [{ deviceName, isSuccess }, setSuccessState] = useState<{
    deviceName: string | null;
    isSuccess: boolean;
  }>({ isSuccess: false, deviceName: null });

  const onLoginAnotherDevice = () => {
    setSuccessState({ isSuccess: false, deviceName: null });
  };

  if (isSuccess) {
    return (
      <ActivateSuccess
        deviceName={deviceName}
        onLoginAnotherDevice={onLoginAnotherDevice}
      />
    );
  } else {
    return <ActivateForm setSuccessState={setSuccessState} />;
  }
};
